
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","fill":"currentColor","stroke":"currentColor","stroke-width":".6"}},[_c('path',{attrs:{"d":"M20.91 18.44L3.37.968C2.634.233 1.475.074.775.772c-.7.698-.541 1.852.196 2.587L18.51 20.83c.738.735 1.896.893 2.597.196.701-.699.53-1.862-.197-2.587z"}}),_c('path',{attrs:{"d":"M18.629 1.17L1.09 18.642c-.737.735-.896 1.889-.196 2.587.7.697 1.859.538 2.596-.196L21.03 3.56c.737-.734.897-1.888.196-2.586-.701-.699-1.869-.53-2.596.196z"}})])])
          )
        }
      }
    